<script setup>
</script>

<template>
  <div class="flex-loader">
    <svg class="flex-loader__logo" viewBox="128 232 1664 616" role="img" :aria-label="$t('shared.common.loading')">
      <path
        class="flex-loader__piece flex-loader__piece--swoosh"
        d="M609.49,508.45s-115.18,64.95-242.76,47.54c-127.59-17.41-176.78-177.32-176.78-177.32l419.55,129.78Z"
      />
      <path
        class="flex-loader__piece flex-loader__piece--band"
        fill-rule="evenodd"
        d="M490.1,627.03l119.38-118.58-422.4-1.86-53.68-.23c-.29,65.8,107.22,119.61,173.9,119.89l182.81.77Z"
      />
      <polygon
        class="flex-loader__piece flex-loader__piece--triangle"
        points="300.66 626.03 609.49 508.45 273.3 842.39 300.66 626.03"
      />

      <g class="flex-loader__word">
        <path d="M680.37,812.46l1.75-400.36,278.28,1.19-.42,95.86-166.85-.71-.29,66.54,136,.58-.39,89.09-136-.58-.65,148.87-111.43-.48Z" />
        <path
          d="M996.4,411.93l108.56.46-1.76,401.88c-14.85-.06-28.1-.12-39.71-.17-11.62-.05-23.53-.1-35.71-.15-12.19-.05-23.24-.1-33.14-.14l1.76-401.88Z"
        />
        <path
          d="M1306.03,820.77c-26.29-.11-49.69-4.2-70.23-12.24-20.54-8.05-37.73-18.95-51.57-32.71-13.85-13.75-24.36-29.53-31.5-47.34-7.17-17.8-10.7-36.51-10.62-56.14.12-28.05,6.52-53.78,19.2-77.17,12.67-23.39,31.23-42.14,55.67-56.26,24.44-14.11,54.57-21.09,90.38-20.94,35.8.15,65.87,7.32,90.19,21.5,24.31,14.17,42.71,32.76,55.18,55.77,12.47,23.01,18.65,48.03,18.53,75.05-.02,5.56-.34,11.2-.94,16.94-.59,5.74-1.28,10.82-2.06,15.26l-210.85-.9c.72,10,3.64,18.13,8.75,24.4,5.11,6.27,11.57,10.84,19.37,13.73,7.79,2.88,15.88,4.35,24.27,4.38,11.8.05,22.96-2.53,33.46-7.75,10.5-5.22,17.49-12.52,20.96-21.9l91.88,26.33c-8.07,15.76-19.27,29.62-33.61,41.58-14.34,11.98-31.23,21.39-50.69,28.26-19.46,6.87-41.38,10.25-65.76,10.15ZM1255.4,637.29l99.43.42c-1.11-9.18-3.84-16.96-8.19-23.33-4.35-6.37-10.05-11.34-17.08-14.9-7.04-3.55-15.12-5.36-24.26-5.4-9.14-.04-17.25,1.7-24.31,5.19-7.07,3.5-12.8,8.42-17.21,14.75-4.41,6.33-7.2,14.09-8.39,23.26Z"
        />
        <path
          d="M1577.61,523.63l42.54,71.95,5.66,11.71,5.77-11.66,43.16-71.59,110.28.47-97.2,144.25,98.78,148.42-110.28-.47-45.97-71.97-5.09-11.15-5.2,11.1-46.59,71.58-110.28-.47,100.06-144.79-95.92-147.85,110.28.47Z"
        />
        <path
          d="M770.79,270.91l-.19,99.42-18.03-.03-21.47-.04c-6.59-.01-9.6-3.03-9.58-9.62l.06-29.94c.01-6.96,3.41-10.16,10.37-10.15l20.91.04.06-33.14-13.37-.03-.03,16.57-17.89-.03.04-22.97c.01-6.78,3.41-10.16,10.38-10.15l38.74.07ZM752.84,334.14l-13.37-.03-.04,21.47,13.37.03.04-21.47Z"
        />
        <path
          d="M713.13,353.65l-.03,16.57-18.26-.03c-6.78-.01-10.16-3.41-10.15-10.18l.14-72.68h-6.59s.03-16.59.03-16.59h6.59s.06-33.13.06-33.13l17.89.03-.06,33.14,10.55.02-.03,16.57-10.55-.02-.12,66.27,10.55.02Z"
        />
        <path
          d="M857.27,254.5l-.03,16.57,12.34.02-.03,16.54-12.34-.02-.16,82.88-17.89-.03.16-82.88h-6.59s.03-16.55.03-16.55h6.59s.04-22.96.04-22.96c.01-6.78,3.41-10.16,10.19-10.15l20.05.04-.03,16.57-12.34-.02Z"
        />
        <rect x="837.12" y="311.89" width="99.43" height="17.89" transform="translate(564.34 1207.06) rotate(-89.89)" />
        <rect x="878.7" y="237.28" width="16.55" height="17.89" transform="translate(639.09 1132.73) rotate(-89.89)" />
        <path d="M944.01,271.24c6.59.01,9.6,3.22,9.58,9.62l-.17,89.81-18.07-.03.16-82.85-13.18-.02-.16,82.85-18.07-.03.19-99.42,39.73.07Z" />
        <path d="M818.94,271c6.59.01,9.41,3.22,9.4,9.62l-.04,23.52-17.89-.03.03-16.55-13.19-.02-.16,82.85-18.08-.03.19-99.42,18.08.03,21.66.04Z" />
      </g>
    </svg>

    <div class="flex-loader__rail"><i /></div>
  </div>
</template>

<style scoped>
.flex-loader {
  --flex-brand: #00d800;
  --flex-ink: #1c1c1c;
  --flex-dim: rgba(28, 28, 28, 0.14);
  --flex-ease: cubic-bezier(0.4, 0, 0.2, 1);
  --flex-build-speed: 1.8s;
  --flex-rail-speed: 1.5s;
  --flex-logo-w: 14rem;
  --flex-rail-w: var(--flex-logo-w);
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}

.flex-loader__logo {
  width: 100%;
  max-width: var(--flex-logo-w);
  height: auto;
  display: block;
}

.flex-loader__word {
  fill: var(--flex-ink);
}

.flex-loader__piece {
  opacity: 0;
  animation-duration: var(--flex-build-speed);
  animation-timing-function: var(--flex-ease);
  animation-iteration-count: infinite;
}

.flex-loader__piece--triangle {
  fill: var(--flex-ink);
  animation-name: flex-build-triangle;
}

.flex-loader__piece--band {
  fill: var(--flex-ink);
  animation-name: flex-build-band;
}

.flex-loader__piece--swoosh {
  fill: var(--flex-brand);
  animation-name: flex-build-swoosh;
}

@keyframes flex-build-triangle {
  0% {
    opacity: 0;
  }
  9%,
  78% {
    opacity: 1;
  }
  88%,
  100% {
    opacity: 0;
  }
}

@keyframes flex-build-band {
  0%,
  17% {
    opacity: 0;
  }
  26%,
  78% {
    opacity: 1;
  }
  88%,
  100% {
    opacity: 0;
  }
}

@keyframes flex-build-swoosh {
  0%,
  34% {
    opacity: 0;
  }
  43%,
  78% {
    opacity: 1;
  }
  88%,
  100% {
    opacity: 0;
  }
}

.flex-loader__rail {
  width: 100%;
  max-width: var(--flex-rail-w);
  height: 2px;
  background: var(--flex-dim);
  position: relative;
  overflow: hidden;
}

.flex-loader__rail i {
  position: absolute;
  inset: 0;
  display: block;
  background: var(--flex-brand);
  transform-origin: left center;
  animation: flex-rail-stretch var(--flex-rail-speed) linear infinite;
}

/*
  Segment kayarken uzunlugu da degisir; uclarda kisalir, orta yolda uzar.
  Anahtar kareler sinus egrisinden orneklendigi icin timing linear kalir,
  boylece hicbir noktada hiz sifira dusmez. Agriculture loader ile ayni egri.
*/
@keyframes flex-rail-stretch {
  0% {
    transform: translateX(0%) scaleX(0.28);
  }
  12.5% {
    transform: translateX(5%) scaleX(0.39);
  }
  25% {
    transform: translateX(25%) scaleX(0.5);
  }
  37.5% {
    transform: translateX(56%) scaleX(0.39);
  }
  50% {
    transform: translateX(72%) scaleX(0.28);
  }
  62.5% {
    transform: translateX(56%) scaleX(0.39);
  }
  75% {
    transform: translateX(25%) scaleX(0.5);
  }
  87.5% {
    transform: translateX(5%) scaleX(0.39);
  }
  100% {
    transform: translateX(0%) scaleX(0.28);
  }
}

@media (prefers-reduced-motion: reduce) {
  .flex-loader__piece,
  .flex-loader__rail i {
    animation: none;
  }

  .flex-loader__piece {
    opacity: 1;
  }

  .flex-loader__rail i {
    transform: scaleX(1);
    opacity: 0.5;
  }
}
</style>
